import { atomFamily } from 'recoil';

const stepperStatusAtomFamily = atomFamily<number, string>({
  key: 'stepperStatusAtomFamily',
  default: 0,
});

export { stepperStatusAtomFamily };
